import { Component, ComponentFactoryResolver, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from '@shared/directives/modal.directive';
import { IModalComponent } from '../../../interfaces';
import { ModalService } from '../../../services/modal.service';
import { ModalItem } from '../modal-item';

@Component({
	selector: 'app-host-modal',
	templateUrl: './host-modal.component.html',
	styleUrls: ['./host-modal.component.scss'],
})
export class HostModalComponent implements OnInit {
	@Input() modals: Array<ModalItem<any>> = [];
	@ViewChild(ModalDirective, { static: true }) appModalHost: ModalDirective;
	constructor(private componentFactoryResolver: ComponentFactoryResolver, private modalService: ModalService) {}

	ngOnInit(): void {
		this.modalService.showModal.subscribe({
			next: (modalData: { type; options }) => {
				if (modalData) {
					this.loadComponent(modalData.type, modalData.options);
				} else {
					this.hideComponent();
				}
			},
		});
	}

	loadComponent(type: string, options?: {}): void {
		const modalItem = this.modals.find((m) => m.data.type === type);
		const componentFactory = this.componentFactoryResolver.resolveComponentFactory(modalItem.component);
		const viewContainerRef = this.appModalHost.viewContainerRef;
		viewContainerRef.clear();

		const componentRef = viewContainerRef.createComponent<IModalComponent<any>>(componentFactory);
		componentRef.instance.data = modalItem.data;
		if (options) {
			componentRef.instance.data.options = { ...modalItem.data.options, ...options };
		}

		componentRef.instance.closeEvent = (e) => this.modalService.closeModal(e);
	}

	hideComponent(e?: any): void {
		this.appModalHost.viewContainerRef.clear();
	}

	@HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
		this.modalService.closeModal();
	}
}
